export const environment = {
  production: false,
  apiUrl:
    "https://as-devl-smart-pd-integration-bvdqcza3aubfhjg0.westeurope-01.azurewebsites.net/api",
  msalConfig: {
    auth: {
      clientId: "0f0b5311-bee7-45c9-b5f7-e795c2f9a94a",
      authority:
        "https://login.microsoftonline.com/76e3e3ff-fce0-45ec-a946-bc44d69a9b7e",
      redirectUri: "/",
    },
  },
  resourceConfig: [
    {
      scopes: ["user.read"],
      uri: "https://graph.microsoft.com/v1.0/me",
    },
    {
      scopes: ["api://SMART-PD-DEVL/User.Read"],
      uri: "https://as-devl-smart-pd-integration-bvdqcza3aubfhjg0.westeurope-01.azurewebsites.net/api",
    },
  ],
};
